import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect(){
    $("body").click(function(e) {
      if ($(e.target).attr("class") != "modal-inner" && $(e.target).parents(".modal-inner").length == 0){
        $('.nycmoca-modal-container').remove();
      }
    });
  }


  close(event){
    event.preventDefault();
    
    // Find and remove the turbo frame
    const turboFrame = document.getElementById('modal');
    if (turboFrame) {
      turboFrame.innerHTML = '';
    }
  }
}
